import * as angular from "angular";
import {IQService} from "angular";
import {Rule} from "../models/rule.model";
import {RulesRequestsService} from "./rules-requests.service";
import {RulesAlertsService} from "./rules-alerts.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class RulesService {

  constructor(private bringozLoaderService: BringozLoaderService, private $q: IQService,
              private rulesRequestsService: RulesRequestsService, private rulesAlertsService: RulesAlertsService) {
  }

  createRule(rule: Rule) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.rulesRequestsService.createRule(rule)
      .then((res) => {
        this.rulesAlertsService.createSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.rulesAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  updateRule(rule: Rule) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.rulesRequestsService.updateRule(rule)
      .then((res) => {
        this.rulesAlertsService.updateSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.rulesAlertsService.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  deleteRule(ruleId: string) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.rulesRequestsService.deleteRule(ruleId)
      .then((res) => {
        this.rulesAlertsService.deleteSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.rulesAlertsService.deleteError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.ruleEngine')
  .service('rulesService', RulesService);
